// Bandeja de leads compartida entre el sitio del usuario final (#sitio) y la vista
// del corredor (#corredor). Persistencia en localStorage (sin backend), como el resto de la demo.
const KEY = 'mbm:leads';

export const ESTADOS = ['Nuevo', 'En análisis', 'Listo para llamar', 'Llamado'];

// 3 leads de ejemplo (ficticios) para que la bandeja del corredor no arranque vacía.
const SEEDS = [
  {
    id: 'seed-1',
    ts: '2026-06-24T14:12:00.000Z',
    marca: 'mbm',
    nombre: 'Valentina Ríos',
    whatsapp: '3105557788',
    necesidad: 'Estrené carro',
    productos: ['Automóvil'],
    entendido: ['No hay letra pequeña sorpresa', 'El deducible se explica en pesos'],
    preguntas: ['¿La póliza del banco me obliga o puedo traer la mía?'],
    consent: true,
    perfil: {
      autos: {
        ramo: 'autos',
        respuestas: [['Carro', 'Mazda CX-30 2024'], ['0 km o usado', '0 km'], ['Ciudad', 'Bogotá'], ['Uso', 'Solo uso particular'], ['Accesorios', 'No, viene de fábrica'], ['Crédito o prenda', 'Sí, tiene crédito o prenda']],
        escalado: null,
        eleccion: 'La Equidad · Auto Protegido',
        opciones: ['La Equidad · Auto Protegido', 'Sura · Todo riesgo', 'Allianz · Todo riesgo'],
      },
    },
    estado: 'Nuevo',
    seed: true,
  },
  {
    id: 'seed-2',
    ts: '2026-06-24T11:40:00.000Z',
    marca: 'mbm',
    nombre: 'Andrés Gómez',
    whatsapp: '3018889900',
    necesidad: 'Nació un hijo',
    productos: ['Vida', 'Educación'],
    entendido: ['Un asesor humano acompaña la decisión'],
    preguntas: ['¿Cómo protejo la educación de mi hija?', '¿Qué pasa si falto yo?'],
    consent: true,
    estado: 'En análisis',
    seed: true,
  },
  {
    id: 'seed-3',
    ts: '2026-06-23T17:05:00.000Z',
    marca: 'mbm',
    nombre: 'Marcela Peña',
    whatsapp: '3126667711',
    necesidad: 'Tembló el sábado',
    productos: ['Hogar', 'Copropiedades'],
    entendido: ['El seguro del crédito cubre la construcción, no los muebles'],
    preguntas: ['¿El valor asegurado alcanza para reconstruir?'],
    consent: true,
    estado: 'Listo para llamar',
    seed: true,
  },
];

function read() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (e) {
    return [];
  }
}

function write(list) {
  try {
    localStorage.setItem(KEY, JSON.stringify(list));
  } catch (e) {
    /* sin localStorage: la demo sigue en memoria */
  }
}

// Los del sitio primero (más recientes arriba) y luego los de ejemplo que no se hayan materializado.
export function listLeads() {
  const saved = read().sort((a, b) => (b.ts || '').localeCompare(a.ts || ''));
  const savedIds = new Set(saved.map((l) => l.id));
  return [...saved, ...SEEDS.filter((s) => !savedIds.has(s.id))];
}

export function ensureDemoLead(marcaId, fresh = false) {
  const list = read();
  const existing = list.find((l) => l.demo);
  if (existing && !fresh) return existing;
  // Reinicio: borra el demo anterior y siembra uno nuevo con la marca activa, estado Nuevo y fecha de ahora.
  if (existing) write(list.filter((l) => !l.demo));
  return saveLead({
    marca: marcaId,
    nombre: 'Camila Restrepo',
    whatsapp: '3204455667',
    necesidad: 'Estrené carro',
    productos: ['Automóvil'],
    entendido: ['No hay letra pequeña sorpresa', 'El deducible se explica en pesos'],
    preguntas: ['¿La póliza del banco me obliga o puedo traer la mía?'],
    consent: true,
    perfil: {
      autos: {
        ramo: 'autos',
        respuestas: [['Carro', 'Mazda CX-30 2024'], ['0 km o usado', '0 km'], ['Ciudad', 'Bogotá'], ['Uso', 'Solo uso particular'], ['Accesorios', 'No, viene de fábrica'], ['Crédito o prenda', 'Sí, tiene crédito o prenda']],
        escalado: null,
        eleccion: 'La Equidad · Auto Protegido',
        opciones: ['La Equidad · Auto Protegido', 'Sura · Todo riesgo', 'Allianz · Todo riesgo'],
      },
    },
    demo: true,
  });
}

// Reiniciar bandeja: borra todo lo guardado (incl. demo y materializados) y deja solo los 3 ejemplos.
export function resetLeads() {
  try { localStorage.removeItem(KEY); } catch (e) { /* noop */ }
}

export function getLead(id) {
  return listLeads().find((l) => l.id === id) || null;
}


export function saveLead(lead) {
  const list = read();
  const full = {
    id: `lead-${Date.now()}`,
    ts: new Date().toISOString(),
    estado: 'Nuevo',
    ...lead,
  };
  list.push(full);
  write(list);
  return full;
}

export function updateLead(id, patch) {
  const list = read();
  const i = list.findIndex((l) => l.id === id);
  if (i >= 0) {
    list[i] = { ...list[i], ...patch };
    write(list);
    return list[i];
  }
  // Es un seed: lo materializamos como guardado para poder actualizar su estado/transcripción.
  const seed = SEEDS.find((l) => l.id === id);
  if (seed) {
    const materialized = { ...seed, ...patch, seed: false };
    list.push(materialized);
    write(list);
    return materialized;
  }
  return null;
}
